import withPricing from './withPricing';
// not all needs to be exported, just for test purpose in the future
import * as pricingAggregator from './pricingAggregator';
import withManuals from './withManuals';

export { withPricing, pricingAggregator, withManuals };



// WEBPACK FOOTER //
// ./src/hoc/index.js